// extracted by mini-css-extract-plugin
export default {"suggested":"suggested-cjvt","path":"path-WjH0","suggestion":"suggestion-KDhw"};